import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'sst-change-sla';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Select change SLA',
};

const sstSelectChangeSla = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { sstSelectChangeSla };
